export const DASHBOARD_GET_DATA = "DASHBOARD_GET_DATA"
